import { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { Icon, theme } from '@socrait/react';

export type SelectOption = {
  label: string;
  value: string;
};

type SelectProps = {
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  height?: number;
  disabledValues?: string[];
};

export function Select({ value, onChange, options, placeholder, height, disabledValues }: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <View style={styles.wrapper}>
      <select
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setIsOpen(false);
        }}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        style={height !== undefined ? { ...styles.select, height } : styles.select}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} disabled={disabledValues?.includes(opt.value)}>
            {opt.label}
          </option>
        ))}
      </select>
      <View style={styles.chevronContainer} pointerEvents="none">
        <Icon
          type="topArrow"
          fill={theme.colors.navy}
          width={theme.spacing.medium}
          style={isOpen ? styles.chevronOpen : styles.chevronClosed}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  select: {
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    height: 50,
    fontSize: theme.fontSizes.small,
    borderRadius: theme.borderRadius.xlarge * 2,
    borderWidth: 1,
    borderColor: theme.colors.darkGray,
    backgroundColor: theme.colors.white,
    paddingLeft: theme.spacing.large,
    paddingRight: theme.spacing.large * 2 + theme.spacing.medium,
    width: '100%',
    color: theme.colors.navy,
    cursor: 'pointer',
    outline: 'none',
    fontFamily: theme.fonts.regular,
  },
  chevronContainer: {
    position: 'absolute',
    right: theme.spacing.large,
    top: '50%',
    transform: [{ translateY: -5 }],
    pointerEvents: 'none',
  },
  chevronOpen: {
    transform: [{ rotate: '0deg' }],
  },
  chevronClosed: {
    transform: [{ rotate: '180deg' }],
  },
});
